import { render, staticRenderFns } from "./ConversionBlock.vue?vue&type=template&id=1ea829e6&"
import script from "./ConversionBlock.vue?vue&type=script&lang=ts&"
export * from "./ConversionBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports